import { betaHost, getHost } from "../src/specific/utils/Navigation/Host";
import { CONFIG } from "./model";

const prodConfig: CONFIG = {
    description:"App de prod qui point vers la base de prod",
    isProduction: true,
    appName: "LILI",
    bundleId: "cool.lili.app",
    packageName: "fr.aotb.lili",
    appLabel: "prod",
    theme: {
        primaryColor: "#FF855F",
        secondaryColor: "#404040"
    }
}

const devConfig: CONFIG = {
    description:"App bêta qui point vers la base de prod",
    isProduction: false,
    appName: "LILI Bêta",
    bundleId: "cool.lili.app",
    packageName: "fr.aotb.lili",
    appLabel: "bêta",
    theme: {
        primaryColor: "#FF855F",
        secondaryColor: "#404040"
    }
}

const host: string = getHost();
let config = prodConfig;
if (betaHost.includes(host) === true) {
    config = devConfig;
} 

export default config;